import React from 'react';
import './EventPopup.css';

const PrivateEventPopup = ({ events = [], onClose }) => {
    const privateEvent = events.find(event => event.eventType === 'private');
    const category = privateEvent?.category;

    return (
        <div className="event-popup-overlay" onClick={onClose}>
            <div className="event-popup" onClick={(e) => e.stopPropagation()}>
                <div className="event-popup-content">
                    <div className="event-popup-item">
                        <p className="private-event-message">
                            <strong>Private Event{category ? ` - ${category}` : ''}</strong>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivateEventPopup;

